import useBackgroundMutation from '@apollo-internal/hooks/useBackgroundMutation';
import SET_NOTIFICATION_AS_READ from '../queries/setNotificationAsReadMutation';
import SET_ALL_NOTIFICATIONS_AS_READ from '../queries/setAllNotificationsAsReadMutation';
import { useUnreadCountStore } from '../NotificationCenterStore';
import { useShallow } from 'zustand/shallow';

const useNotificationActions = (markAsRead, markAllAsRead) => {
  const { setUnreadCount, decrementUnreadCount } = useUnreadCountStore(
    useShallow(state => ({
      setUnreadCount: state.setUnreadCount,
      decrementUnreadCount: state.decrementUnreadCount
    }))
  );

  const [setAsRead, { error: setAsReadError }] = useBackgroundMutation(SET_NOTIFICATION_AS_READ);
  const [setAllAsRead, { error: setAllAsReadError }] = useBackgroundMutation(
    SET_ALL_NOTIFICATIONS_AS_READ
  );

  const handleMarkAsReadClick = async notificationId => {
    await setAsRead({ variables: { notificationId } });
    markAsRead(notificationId);
    decrementUnreadCount();
  };

  const handleMarkAllAsReadClick = async () => {
    await setAllAsRead();
    markAllAsRead();
    setUnreadCount(0);
  };

  return {
    notificationActionError: setAsReadError || setAllAsReadError,
    handleMarkAsReadClick,
    handleMarkAllAsReadClick
  };
};

export default useNotificationActions;
